import { Box, Flex, FormLabel } from '@chakra-ui/react';
import { IconCircleInfo } from 'central-icons/IconCircleInfo';

import { Badge, RevelioTooltip } from '@revelio/ui';

import styles from '../preference-editors/preference-editors.module.css';

export const PreferenceEditorSectionHeading = ({
  title,
  tooltip,
  indicateDiff,
}: {
  title: string;
  tooltip?: string;
  indicateDiff: boolean;
}) => {
  return (
    <Box width="full" mb={1}>
      <Flex alignItems="center" justifyContent="space-between">
        <Flex alignItems="center" color="text.primary" gap={1}>
          <FormLabel
            className={styles.sectionHeading}
            fontSize="sm"
            fontWeight="semibold"
            mb={0}
            mr={0}
          >
            {title}
          </FormLabel>
          {tooltip && (
            <RevelioTooltip label={tooltip} placement="right">
              <Box>
                <IconCircleInfo size={16} cursor="pointer" />
              </Box>
            </RevelioTooltip>
          )}
        </Flex>

        {indicateDiff && (
          <Box mx={1}>
            <Badge size="sm" className={styles.sectionDiffIndicator} />
          </Box>
        )}
      </Flex>
    </Box>
  );
};
